import { useEffect, useState } from 'react';
import Avatar from '@mui/material/Avatar';

interface ProfilePhotoAvatarProps {
  file: File | null;
}

export default function ProfilePhotoAvatar({ file }: ProfilePhotoAvatarProps) {
  const [previewUrl, setPreviewUrl] = useState<string>();

  useEffect(() => {
    if (!file) {
      setPreviewUrl(undefined);
      return;
    }

    const reader = new FileReader();
    reader.onload = () => setPreviewUrl(reader.result as string);
    reader.readAsDataURL(file);
    return () => reader.abort();
  }, [file]);

  return (
    <Avatar
      src={previewUrl}
      alt={file ? 'Profile picture preview' : undefined}
      sx={{
        width: 48,
        height: 48,
        ...(!previewUrl
          ? {
              bgcolor: 'primary.main',
              color: 'common.white',
            }
          : {}),
      }}
    />
  );
}
